import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { MarketTicker } from '../components/MarketTicker';
import { MarketStrip } from '../components/MarketStrip';
import { HeroSection } from '../components/HeroSection';
import { BottomArticles } from '../components/BottomArticles';
import { AdPlaceholder } from '../components/AdPlaceholder';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-409">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-410">
        <Header data-id="element-411" />
        <Navigation data-id="element-412" />
      </div>

      {/* Full-width ticker bar */}
      <MarketTicker data-id="element-413" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-414">
        {/* Top Banner Ad */}
        <div className="py-6 flex justify-center" data-id="element-415">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[90px]" text="Wenda Ingredients Advertisement" data-id="element-416" />
        </div>

        <main data-id="element-417">
          <HeroSection data-id="element-418" />
          <MarketStrip autoScroll data-id="element-419" />
          <BottomArticles data-id="element-420" />
        </main>

        {/* Bottom Banner Ad */}
        <div className="py-8 border-t border-gray-200 flex justify-center" data-id="element-421">
          <AdPlaceholder width="w-full max-w-[970px]" height="h-[90px]" text="Intralox Advertisement" data-id="element-422" />
        </div>
      </div>
    </div>;
}